var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.425 15C5.625 13.875 7.2 13.125 9 13.125c1.725 0 3.375.675 4.575 1.875M10.575 7.05c.9.9.9 2.325 0 3.15-.9.825-2.325.9-3.15 0-.825-.9-.9-2.325 0-3.15.9-.825 2.25-.9 3.15 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 12.75c-.45-.9-.75-1.95-.75-3C2.25 6 5.25 3 9 3s6.75 3 6.75 6.75c0 1.05-.3 2.1-.75 3"
  })));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzYzNGJlNmFiZjczYWNiOWZkMTk0YmVlYWFlYjI1YjAuc3ZnIjs=";